import {
  AccountBalanceObjectType,
  AccountTransactionObjectType,
  ActivityObjectType,
  AppointmentAvailabilityObjectType,
  AppointmentOptionObjectType,
  AppointmentTypeObjectType,
  AttachmentObjectType,
  AudienceMemberObjectType,
  BatchObjectType,
  BillingDetailsObjectType,
  CampaignObjectType,
  ContactObjectType,
  ConversationObjectType,
  CouponObjectType,
  CustomerObjectType,
  DiscountObjectType,
  DisputeObjectType,
  EventAnalyticsObjectType,
  FeedbackObjectType,
  FieldChoiceObjectType,
  FieldObjectType,
  FileObjectType,
  FormResponseObjectType,
  InviteObjectType,
  MarketingAnalyticsObjectType,
  MemberObjectType,
  MembershipObjectType,
  MembershipPackageObjectType,
  MessageObjectType,
  NoteObjectType,
  NotificationObjectType,
  NotificationPreferencesObjectType,
  OrderItemObjectType,
  OrderObjectType,
  PaymentObjectType,
  PaymentSourceObjectType,
  PayoutBalanceObjectType,
  PayoutBankAccountObjectType,
  PayoutCardObjectType,
  PayoutObjectType,
  ProductCategoryObjectType,
  ProductObjectType,
  ProgramAnalyticsObjectType,
  ProgramAttendeeObjectType,
  ProgramEventObjectType,
  ProgramEventSeriesObjectType,
  ProgramObjectType,
  ProgramSuggestionObjectType,
  QuickFilterObjectType,
  RefundObjectType,
  RefundPolicyObjectType,
  RegistrationObjectType,
  RegistrationOptionObjectType,
  RelationObjectType,
  ReportObjectType,
  SessionCreditBalanceObjectType,
  SessionCreditObjectType,
  SessionPackageObjectType,
  ShortLinkAnalyticsObjectType,
  ShortLinkObjectType,
  StockImageObjectType,
  TaxItemObjectType,
  TaxRateObjectType,
  TerminalObjectType,
  UserObjectType,
  VenueObjectType,
} from '@citruscamps/citrus-client'
import { QueryKey } from 'react-query'
import { Pagination } from '../interfaces/pagination'

export type ObjectKeyType =
  | AccountBalanceObjectType
  | AccountTransactionObjectType
  | ActivityObjectType
  | AppointmentAvailabilityObjectType
  | AppointmentOptionObjectType
  | AppointmentTypeObjectType
  | AttachmentObjectType
  | AudienceMemberObjectType
  | BatchObjectType
  | BillingDetailsObjectType
  | CampaignObjectType
  | ContactObjectType
  | ConversationObjectType
  | CouponObjectType
  | CustomerObjectType
  | DiscountObjectType
  | DisputeObjectType
  | EventAnalyticsObjectType
  | FeedbackObjectType
  | FieldChoiceObjectType
  | FieldObjectType
  | FileObjectType
  | FormResponseObjectType
  | InviteObjectType
  | MarketingAnalyticsObjectType
  | MemberObjectType
  | MembershipObjectType
  | MembershipPackageObjectType
  | MessageObjectType
  | NoteObjectType
  | NotificationObjectType
  | NotificationPreferencesObjectType
  | OrderItemObjectType
  | OrderObjectType
  | PaymentObjectType
  | PaymentSourceObjectType
  | PayoutBalanceObjectType
  | PayoutBankAccountObjectType
  | PayoutCardObjectType
  | PayoutObjectType
  | ProductObjectType
  | ProductCategoryObjectType
  | ProgramAnalyticsObjectType
  | ProgramAttendeeObjectType
  | ProgramEventObjectType
  | ProgramEventSeriesObjectType
  | ProgramObjectType
  | ProgramSuggestionObjectType
  | QuickFilterObjectType
  | RefundObjectType
  | RefundPolicyObjectType
  | RegistrationObjectType
  | RegistrationOptionObjectType
  | RelationObjectType
  | ReportObjectType
  | SessionCreditBalanceObjectType
  | SessionCreditObjectType
  | SessionPackageObjectType
  | ShortLinkAnalyticsObjectType
  | ShortLinkObjectType
  | StockImageObjectType
  | TaxItemObjectType
  | TaxRateObjectType
  | TerminalObjectType
  | UserObjectType
  | VenueObjectType
  | 'billing_product'
  | 'cost_breakdown'
  | 'available_date'
  | 'available_time'
  | 'country'
  | 'region'
  | 'tag'
  | 'features'
  | 'favicon'
  | 'verify_email'
  | 'token'
  | 'message_tracking'
  | 'csrf_token'
  | 'geocoder'
  | 'message_preview'
  | 'dimensions'
  | 'qrcode'
  | 'cropped_image'
  | 'additional_program'
  | 'contact_property'
  | 'contact_property_value'
  | 'program_attendee_property'
  | 'program_attendee_property_value'

interface IGenerateBaseKeyProps {
  type: ObjectKeyType
  program_id: string | undefined
  query?: unknown
}

export const generateBaseKey = (props: IGenerateBaseKeyProps): QueryKey => {
  const { program_id, type, query } = props
  const keys: QueryKey = [program_id, type]
  return query ? keys.concat(query) : keys
}

interface IGenerateItemKeyProps extends IGenerateBaseKeyProps {
  id: string | undefined
}

export const generateItemKey = (props: IGenerateItemKeyProps): QueryKey => {
  const { program_id, type, id, query } = props
  const keys: QueryKey = [program_id, type, id]
  return query ? keys.concat(query) : keys
}

interface IGenerateListKeyProps extends IGenerateBaseKeyProps {
  pagination: Pagination
  sort: string | undefined
  order: 'ASC' | 'DESC' | undefined
  search?: string
}

export const generateListKey = (props: IGenerateListKeyProps): QueryKey => {
  const { program_id, type, pagination, sort, order, query = {}, search = '' } = props
  return [program_id, type, pagination, sort, order, query, search]
}
